import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../Button/PlainButtonOrLink';
import s from './CoreBadgeButton.scss';
var CoreBadgeButton = function (_a) {
    var type = _a.type, recipient = _a.recipient, badges = _a.badges, className = _a.className, children = _a.children, biData = _a.biData, pushAwardsModal = _a.pushAwardsModal;
    return (React.createElement(PlainButtonOrLink, { className: c(s['toggle'], className), onClick: function () {
            return pushAwardsModal({
                badges: badges,
                recipient: recipient,
                defaultActiveType: type,
            });
        } }, children));
};
CoreBadgeButton.displayName = 'CoreBadgeButton';
export default CoreBadgeButton;
//# sourceMappingURL=CoreBadgeButton.js.map